window.bundleapp = window.bundleapp || {};
window.bundleapp.settings = Object.assign({}, window.bundleapp.settings || {}, {
  bab: {
    productImage: 600
  }
});

const waitForElement = (selector, callback, delay = 0, failsafeDelay) => {
  const observer = new MutationObserver((mutations, obs) => {
    const element = document.querySelector(selector);
    if (element) {
      obs.disconnect();
      if (typeof callback === "function") {
        setTimeout(() => {
          callback(element);
        }, delay);
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  if (failsafeDelay) setTimeout(() => observer.disconnect(), failsafeDelay);
};

const babMinimums = {
  // Example structure:
  // "9556565229815": {
  //   49231431958775: 60,
  //   49231431991543: 120
  // }
};

//if awtomic allocation page like https://kpvjpx-he.myshopify.com/tools/bundle-subscriptions/allocation/265
if (window.location.pathname.includes("/tools/bundle-subscriptions/allocation/")) {
  document.body.classList.add("awt-allocation");
  const allocationId = window.location.pathname.split("/").pop();
  if (allocationId) {
    document.body.classList.add(`awt-allocation-${allocationId}`);
  }
}

//if awtomic customer portal
if (window.location.pathname.includes("/tools/bundle-subscriptions") && window.location.search.includes("subscriptionId=")) {
  document.body.classList.add("awt-cp");

  // CP PRICE CHECK
  waitForElement(".bundle-table__body-row--bab-parent", (element) => {
    const checkBabEdit = (bundleId, variantId) => {
      const minimumPrice = babMinimums[bundleId]?.[variantId] || 0;

      const setAddToCartMinimumPrice = () => {
        const bundleContainer = document.querySelector(".bundleapp-modal__container--complete-screen > .bundle-container");

        if (!bundleContainer) return;

        const infoDiv = document.createElement("div");
        infoDiv.className = "minimum-price-info";
        infoDiv.innerText = `Minimum price of $${minimumPrice} is required for this club.`;

        const footerDiv = bundleContainer.querySelector("footer > div");
        if (footerDiv) {
          const lastDiv = footerDiv.querySelector("div:last-child");
          if (lastDiv) {
            footerDiv.insertBefore(infoDiv, lastDiv);
          }
        }

        document.body.addEventListener("click", (e) => {
          const price = document.querySelector("div > span.bundle-text--emphasis").innerText;
          const innerPrice = parseFloat(price.replace(/[^0-9.,]/g, "").replace(",", ""));

          const addToCartButton = document.querySelector(".bundleapp-modal__container--complete-screen footer > div > div > button");
          if (innerPrice < minimumPrice) {
            addToCartButton.classList.add("priceNotMet");
            document.body.classList.add("priceNotMet");
          } else {
            addToCartButton.classList.remove("priceNotMet");
            document.body.classList.remove("priceNotMet");
          }
        });
      };

      const checkIfPriceLabel = () =>
        document.querySelector(".bundleapp-modal__container--complete-screen footer > div > div:last-child > div > span:nth-child(2)");

      let priceLabelSet = false;

      if (checkIfPriceLabel()) {
        setAddToCartMinimumPrice();
      } else {
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (!priceLabelSet && mutation.addedNodes.length) {
              if (checkIfPriceLabel()) {
                setAddToCartMinimumPrice();
                priceLabelSet = true;
                observer.disconnect();
              }
            }
          });
        });

        observer.observe(document.body, {
          childList: true,
          subtree: true
        });

        setTimeout(() => {
          observer.disconnect();
        }, 5000);
      }
    };

    Object.keys(babMinimums).forEach((bundleId) => {
      Object.keys(babMinimums[bundleId]).forEach((variantId) => {
        const selector = `tr[class*="${variantId}"]`;
        const element = document.querySelector(selector);
        console.log(selector, element);
        if (element) element.addEventListener("click", () => checkBabEdit(bundleId, variantId));
      });
    });
  });
}

//if awtomic subs list / my subscriptions
if (/^\/tools\/bundle-subscriptions\/?$/.test(location.pathname) && !location.search) {
  document.body.classList.add("awt-my-subs");
}

//if awtomic bab purchase flow
if (window.location.pathname.includes("/tools/bundle-subscriptions/bundle/")) {
  window.Awtomic = window.Awtomic || {};
  window.Awtomic.getBabSelection = () => {
    //babProductId is in a class of an element, the element is div.bundle-container.pv_xxxxxxx where xxxxxxx is the bab product id
    const babProductId = document
      .querySelector(".bundle-container")
      ?.className.split(" ")
      .find((c) => c.startsWith("pv_"))
      ?.split("_")[1];
    if (!babProductId) return { object: {}, queryString: "" };

    const bundleProductCards = document.querySelectorAll(".bundle-product-card");

    const bundleSelectedProducts = {};
    bundleProductCards.forEach((card) => {
      const productId = card.getAttribute("data-pid");
      const quantityElement = card.querySelector(".bundle-product-card__quantity-button-container > span");
      const quantity = quantityElement ? parseInt(quantityElement.innerHTML) : 0;

      if (productId && quantity > 0) {
        bundleSelectedProducts[productId] = quantity;
      }
    });

    // Create query string format
    const queryString = Object.entries(bundleSelectedProducts)
      .map(([id, quantity]) => `${id}=${quantity}`)
      .join("&");

    // Create full URL with query string
    const currentUrl = window.location.href;
    const separator = currentUrl.includes("?") ? "&" : "?";
    const fullUrl = queryString ? `${currentUrl}${separator}${queryString}` : currentUrl;

    return {
      object: { [babProductId]: bundleSelectedProducts },
      queryString: queryString,
      fullUrl: fullUrl
    };
  };

  const urlParts = window.location.pathname.split("/");
  const bundleId = urlParts[urlParts.length - 1];
  if (bundleId) {
    document.body.classList.add(`awt-bundle-${bundleId}`);

    if (babMinimums[bundleId]) {
      // Wait for footer to exist first, then set up the price checking
      waitForElement(".bundleapp-modal__container--complete-screen footer", () => {
        // Get variant ID from bundle container classes (e.g., div.bundle-container p_9556565229815.pv_49231431991543)
        const getVariantId = () => {
          const bundleContainer = document.querySelector(".bundle-container");
          if (!bundleContainer) return null;

          const classes = bundleContainer.className.split(" ");
          const variantClass = classes.find((c) => c.startsWith("pv_"));
          return variantClass ? variantClass.split("_")[1] : null;
        };

        let currentVariantId = getVariantId();

        const updatePriceChecking = (variantId) => {
          const minimumPrice = babMinimums[bundleId]?.[variantId] || 0;
          console.log(`Setting up price checking for variant ${variantId} with minimum price $${minimumPrice}`);

          const setAddToCartMinimumPrice = () => {
            const bundleContainer = document.querySelector(".bundleapp-modal__container--complete-screen > .bundle-container");

            if (!bundleContainer) return;

            // Remove existing minimum price info if any
            const existingInfo = bundleContainer.querySelector(".minimum-price-info");
            if (existingInfo) {
              existingInfo.remove();
            }

            const infoDiv = document.createElement("div");
            infoDiv.className = "minimum-price-info";
            infoDiv.innerText = `Minimum price of $${minimumPrice} is required for this club.`;

            const footerDiv = bundleContainer.querySelector("footer > div");
            if (footerDiv) {
              const lastDiv = footerDiv.querySelector("div:last-child");
              if (lastDiv) {
                footerDiv.insertBefore(infoDiv, lastDiv);
              }
            }

            document.body.addEventListener("click", (e) => {
              const price = document.querySelector("div > span.bundle-text--emphasis").innerText;
              const innerPrice = parseFloat(price.replace(/[^0-9.,]/g, "").replace(",", ""));

              const addToCartButton = document.querySelector(".bundleapp-modal__container--complete-screen footer > div > div > button");
              if (innerPrice < minimumPrice) {
                addToCartButton.classList.add("priceNotMet");
                document.body.classList.add("priceNotMet");
              } else {
                addToCartButton.classList.remove("priceNotMet");
                document.body.classList.remove("priceNotMet");
              }
            });
          };

          const checkIfPriceLabel = () =>
            document.querySelector(".bundleapp-modal__container--complete-screen footer > div > div:last-child > div > span:nth-child(2)");

          let priceLabelSet = false;

          if (checkIfPriceLabel()) {
            setAddToCartMinimumPrice();
          } else {
            const observer = new MutationObserver((mutations) => {
              mutations.forEach((mutation) => {
                if (!priceLabelSet && mutation.addedNodes.length) {
                  if (checkIfPriceLabel()) {
                    setAddToCartMinimumPrice();
                    priceLabelSet = true;
                    observer.disconnect();
                  }
                }
              });
            });

            observer.observe(document.body, {
              childList: true,
              subtree: true
            });

            setTimeout(() => {
              observer.disconnect();
            }, 5000);
          }
        };

        // Initial setup if we have a variant ID
        if (currentVariantId) {
          updatePriceChecking(currentVariantId);
        }

        // Watch for variant changes in the bundle container
        const variantObserver = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === "attributes" && mutation.attributeName === "class") {
              const newVariantId = getVariantId();
              if (newVariantId && newVariantId !== currentVariantId) {
                console.log(`Variant changed from ${currentVariantId} to ${newVariantId}`);
                currentVariantId = newVariantId;
                updatePriceChecking(currentVariantId);
              }
            }
          });
        });

        // Observe the bundle container for class changes
        const bundleContainer = document.querySelector(".bundle-container");
        if (bundleContainer) {
          variantObserver.observe(bundleContainer, {
            attributes: true,
            attributeFilter: ["class"]
          });
        }
      });
    }
  }
}

//cart rollup
document.body.addEventListener("click", async (event) => {
  if (!event.target.matches(".cart__remove-bundle *, .cart__remove-bundle[data-bundle-id]")) return;

  const bundleElement = event.target.closest(".cart__remove-bundle") || (event.target.hasAttribute("data-bundle-id") ? event.target : null);
  const bundle_id = bundleElement ? bundleElement.getAttribute("data-bundle-id") : null;

  if (bundle_id) {
    event.preventDefault();
    try {
      // Get current cart contents
      const cart = await (await fetch("/cart.js")).json();

      // Create data object for cart update AJAX call
      const data = {
        updates: cart.items.reduce((acc, item) => (item.properties?._bundleUid == bundle_id ? { ...acc, [item.key]: 0 } : acc), {})
      };

      // API call to update the cart contents and set the bundle item quantities to 0
      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data)
      });

      response.ok && (window.location.href = "/cart");
    } catch (error) {
      console.error(error);
    }
  }
});

//auto-select the prepaid (gift) subscription plan on specific club products.
//the prepaid plan is recognized as the widget radio whose selling-plan-id is listed
//as a gift-eligible plan (data-awt-gift-plan-ids); the quarterly plan is not listed.
//works even while the widget is visually hidden.
(() => {
  const AUTO_PREPAID_PRODUCT_IDS = ["10215798604074", "10129564631338"];

  const getGiftPlanIds = () => {
    const ids = new Set();
    document.querySelectorAll("[data-awt-gift-plan-ids]").forEach((el) => {
      try {
        JSON.parse(el.getAttribute("data-awt-gift-plan-ids")).forEach((id) => ids.add(String(id)));
      } catch (e) {}
    });
    return ids;
  };

  const selectPrepaidPlan = (widget) => {
    const giftPlanIds = getGiftPlanIds();
    if (!giftPlanIds.size) return;

    let target = null;
    widget.querySelectorAll("[data-sw-option-radio][data-sw-selling-plan-id]").forEach((radio) => {
      if (giftPlanIds.has(String(radio.getAttribute("data-sw-selling-plan-id")))) target = radio;
    });

    if (target && !target.checked) target.click();
  };

  AUTO_PREPAID_PRODUCT_IDS.forEach((pid) => {
    const selector = `.awtomic-sw[data-sw-product-id="${pid}"]`;
    const enforce = () => {
      const widget = document.querySelector(selector);
      if (widget) selectPrepaidPlan(widget);
    };

    waitForElement(
      selector,
      () => {
        enforce();
        // re-enforce in case the app hydrates / re-renders and resets the selection
        const observer = new MutationObserver(enforce);
        observer.observe(document.body, { childList: true, subtree: true });
        setTimeout(() => observer.disconnect(), 8000);
      },
      0,
      10000
    );
  });
})();

//keep the buy-buttons wrapper flagged with the prepaid modifier class.
//liquid can only see ?selling_plan= at render time, but awtomic writes the real
//selection into the hidden selling_plan input after render (and again whenever the
//customer switches plan), so the class is driven from that input instead.
//the prepaid plan ids come from liquid via data-prepaid-plan-ids.
(() => {
  const WRAPPER_SELECTOR = ".product-block-buy-buttons";
  const PREPAID_CLASS = "product-block-buy-buttons--prepaid";

  // TEMP DEBUG — remove once confirmed working.
  // run __prepaidDebug() in the console for a snapshot, __prepaidDebug.log for the history.
  const DEBUG = true;
  const history = [];
  const log = (event, detail) => {
    if (!DEBUG) return;
    const entry = { t: Math.round(performance.now()), event, ...detail };
    history.push(entry);
    console.log("[prepaid]", event, entry);
  };

  const syncWrapper = (wrapper, reason) => {
    const prepaidIds = (wrapper.getAttribute("data-prepaid-plan-ids") || "")
      .split(",")
      .filter(Boolean);
    const input = wrapper.querySelector('[name="selling_plan"]');
    const selected = input ? String(input.value || "") : "";
    const isPrepaid = selected !== "" && prepaidIds.indexOf(selected) !== -1;
    const was = wrapper.classList.contains(PREPAID_CLASS);

    // only write on an actual change: setAttribute always emits a mutation record, and the
    // observer below would otherwise re-enter this on every write.
    if (was !== isPrepaid) {
      wrapper.classList.toggle(PREPAID_CLASS, isPrepaid);
    }
    if (wrapper.getAttribute("data-prepaid-plan") !== String(isPrepaid)) {
      wrapper.setAttribute("data-prepaid-plan", String(isPrepaid));
    }
    if (wrapper.getAttribute("data-selected-selling-plan") !== selected) {
      wrapper.setAttribute("data-selected-selling-plan", selected);
    }

    if (was !== isPrepaid) {
      log("class-changed", { reason, from: was, to: isPrepaid, selected, prepaidIds });
    }
    return { prepaidIds, inputFound: !!input, selected, isPrepaid };
  };

  const syncAll = (reason) => {
    const wrappers = document.querySelectorAll(WRAPPER_SELECTOR);
    if (!wrappers.length) log("no-wrapper-found", { reason, selector: WRAPPER_SELECTOR });
    wrappers.forEach((w) => syncWrapper(w, reason));
  };

  // full snapshot of everything this feature depends on
  const snapshot = () => {
    const wrappers = [...document.querySelectorAll(WRAPPER_SELECTOR)].map((w) => ({
      hasPrepaidClass: w.classList.contains(PREPAID_CLASS),
      className: w.className,
      dataPrepaidPlan: w.getAttribute("data-prepaid-plan"),
      dataPrepaidPlanIds: w.getAttribute("data-prepaid-plan-ids"),
      dataSelectedSellingPlan: w.getAttribute("data-selected-selling-plan"),
      sellingPlanInputInside: !!w.querySelector('[name="selling_plan"]'),
      sellingPlanInputValue: w.querySelector('[name="selling_plan"]')?.value ?? null,
    }));

    const allInputs = [...document.querySelectorAll('[name="selling_plan"]')].map((i) => ({
      value: i.value,
      valueAttr: i.getAttribute("value"),
      className: i.className,
      insideWrapper: !!i.closest(WRAPPER_SELECTOR),
      formId: i.form ? i.form.id : null,
    }));

    const out = {
      url: location.href,
      bodyClasses: document.body.className,
      wrapperCount: wrappers.length,
      wrappers,
      sellingPlanInputs: allInputs,
      awtomicWidgets: [...document.querySelectorAll(".awtomic-sw")].map((w) => ({
        productId: w.getAttribute("data-sw-product-id"),
        checkedRadioPlanId:
          w.querySelector("[data-sw-option-radio]:checked")?.getAttribute("data-sw-selling-plan-id") ??
          null,
      })),
      scriptLoaded: true,
    };
    console.log("[prepaid] SNAPSHOT", JSON.stringify(out, null, 2));
    return out;
  };

  const init = () => {
    log("init", { readyState: document.readyState });
    syncAll("init");
    if (DEBUG) snapshot();

    // the widget assigns input.value as a property, which fires no mutation and no event,
    // so watch the DOM broadly and also re-read right after any plan radio interaction.
    const observer = new MutationObserver(() => syncAll("mutation"));
    observer.observe(document.body, { childList: true, subtree: true, attributes: true });

    ["change", "click"].forEach((evt) =>
      document.addEventListener(evt, () => requestAnimationFrame(() => syncAll(evt)), true)
    );

    // fallback for the initial hydration window, where the app may set the plan silently
    const poll = setInterval(() => syncAll("poll"), 500);
    setTimeout(() => {
      clearInterval(poll);
      log("poll-stopped", {});
      if (DEBUG) snapshot();
    }, 10000);
  };

  if (DEBUG) {
    window.__prepaidDebug = snapshot;
    window.__prepaidDebug.log = history;
    window.__prepaidDebug.sync = syncAll;
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
